exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fill-view-catalog-helper[data-v-78ad1c2e] label.label {\n  color: rgba(72, 72, 72, 0.7);\n}\n.fill-view-catalog-helper[data-v-78ad1c2e] div.ant-select-selection {\n  background-color: rgba(233, 241, 251, 0.1);\n}\n.fill-view-catalog-helper[data-v-78ad1c2e] div.ant-select-selection-selected-value {\n  color: rgba(72, 72, 72, 0.7);\n}\n", ""]);

// exports
